import { render, staticRenderFns } from "./group-member-toon.vue?vue&type=template&id=2b7c91fa&lang=pug&"
import script from "./group-member-toon.vue?vue&type=script&lang=js&"
export * from "./group-member-toon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports